const VideoRenditionTypes = {
  MP4: 'Mp4'
};

export default VideoRenditionTypes;
